// components/PriceRangeFilter/styles.js
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 28px;
  margin-bottom: 28px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey.white};
`;

export const ClearButton = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.outher.danger};
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  transition: all 0.2s;

  span {
    font-size: 0.75rem;
  }

  &:hover {
    text-decoration: underline;
    opacity: 0.8;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex-direction: row;
  gap: 4px;
`;

export const Input = styled.input`
  max-width: 220px;
  padding: 10px 24px;
  border-radius: 32px;
  border: 1px solid ${({ theme }) => theme.colors.grey[200]};
  background: ${({ theme }) => theme.colors.grey.white};
  color: ${({ theme }) => theme.colors.grey.black};
  font-size: 20px;
  text-align: center;
  transition: all 0.2s;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
    padding: 10px;
    font-size: 16px;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.grey[500]};
    text-align: center;
  }

  &:hover {
    border-color: #bbb;
  }
`;

export const ErrorMessage = styled.div`
  margin-top: 8px;

  span {
    color: ${({ theme }) => theme.colors.outher.danger};
  }
`;
